module.exports = __webpack_public_path__ + "img/shirt-long-sleeve.0336eb75.svg";